module.exports = {
	"buyerAssurance": "Purchases made on 1stdibs are covered by our buyer protection program.",
	"meta": {
		"title": "Buyer Protection on 1stdibs"
	},
	"staticMarketing": {
		"banner": "Buyer Protection on 1stdibs",
		"bannerImgAttrs": {
			"src": "/static/images/buyers/buyerAssuranceBannerImage.jpg",
			"alt": "Buyer Assurance Banner"
		},
		"description": [
			"We know buying unique pieces online requires trust. Thanks to our buyer protection program, you can shop world’s most iconic pieces and signature works with confidence. As long as you order via the 1stdibs secure checkout, your purchase will be fully protected.",
			"In the unlikely event you make a purchase through our secure checkout and receive an item that is significantly not as described or has been damaged in transit, we want to make it right <a href='#details'>(see details)</a>. Please email <a href='mailto:support@1stdibs.com' target='_blank'>support@1stdibs.com</a> within 7 days of receiving your item to let us know there is a problem, and we will work with you and the dealer to reach the best possible resolution, whether that be arranging for a return, a full refund, or a repair with a trusted restorer.",
			"Buyer protection is a part of our broader promise to 1stdibs customers."
		],
		"benefitsTitle": "The 1stdibs Promise: Shop With Confidence",
		"benefits": [
			{
				"name": "Buyer Protection",
				"description": "Guaranteed purchase protection when you check out on 1stdibs",
				"svgId": "buyer-assurance"
			},
			{
				"name": "Secure Online Transactions",
				"description": "Safe and secure payment through our checkout process",
				"svgId": "lock"
			},
			{
				"name": "Store-To-Door Shipping",
				"description": "Easy shipping around the world",
				"svgId": "truck-moving"
			},
			{
				"name": "Dedicated Customer Support",
				"description": "Timely answers to all your questions from our support specialists",
				"svgId": "customer-support"
			}
		]
	},
	"programDetails": [
		{
			"heading": "In order to qualify for our Buyer Protection Program, your purchase must meet the following criteria:",
			"details": [
				[
					"The order was placed online through our secure checkout",
					"The item was significantly not as described, damaged in transit or never arrived",
					"You reported the issue within 7 days of delivery date (or within 180 days of the purchase date if the item never arrived)"
				]
			]
		},
		{
			"heading": "The Buyer Protection Program does not apply if:",
			"details": [
				[
					"You are returning an accurately described item, outside of the dealer's stated return policy",
					"You elected to arrange your own shipping or pick the item up in person, and the item was damaged at pickup or during shipping",
					"You purchased the item directly from the dealer (e.g. in store) without using our secure checkout"
				]
			],
			"footer": [
				"For more detailed examples pertaining to buyer protection eligibility, please visit our <a href='https://support.1stdibs.com/s/article/Buyer-Protection-Guaranteed' target='_blank'>support center</a>."
			]
		}
	],
	"svgIcon": "buyer-assurance",
	"text": "Buyer Protection Guaranteed",
	"tooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/about/promise/' target='_blank'>View details.</a>"
	},
	"tradeTooltip": {
		"title": "Buyer Protection",
		"text": "Purchases made on 1stdibs are covered by our buyer protection program. In the rare instance that a purchase doesn't meet your expectations, our team of specialists is here to help. <a href='/trade/promise/' target='_blank'>View details.</a>"
	}
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/buyerAssurance.json
// module id = 1012
// module chunks = 4 7 14